/**
 * Mixin to handle item availability logic for showings and delivery locations.
 *
 * @mixin
 * @requires order - Must be provided via inject
 * @requires deliveryLocations - Must be provided via configuration
 *
 * Key features:
 * - Checks item availability based on showing badges
 * - Handles theater seat delivery locations
 * - Validates category requirements for showings
 */
import { DELIVERY_LOCATION_TYPES } from 'src/models/delivery-location/DeliveryLocation'
export default {
  configuration: ['deliveryLocations'],
  inject: ['order'],
  methods: {
    /**
     * Determines if an item is available for purchase based on multiple criteria
     *
     * @param {Object} item - The item to check availability for
     * @param {boolean} item.active - Whether the item is active
     * @param {boolean} item.availableOnline - Whether the item can be purchased online
     * @param {Object} item.category - The item's category with showing badge requirements
     * @returns {boolean} True if the item is available, false otherwise
     */
    isItemAvailable (item) {
      if (!this.order) return true
      const showing = this.order.nextShowing || this.order.currentShowing
      let showingBadgeIds = showing?.showingBadgeIds
      if (!showingBadgeIds) {
        const deliveryLocation = _.find(this.deliveryLocations.data, { name: this.order.deliveryLocation, type: DELIVERY_LOCATION_TYPES.THEATER_SEAT })
        showingBadgeIds = !!deliveryLocation?.screen?.computedShowingBadges && _.map(deliveryLocation?.screen?.computedShowingBadges, 'id')
      }
      const isCategoryAvailableForShowing = !item.category ||
        !item?.category?.showingBadgeIds?.length ||
        !item.category.requireShowingBadges ||
        (!showingBadgeIds && !item.category.requireShowingBadges) ||
        (!!showingBadgeIds && item.category.requireAllShowingBadges && item.category.requireShowingBadges === (_.difference(item.category.showingBadgeIds, showingBadgeIds).length === 0)) ||
        (!!showingBadgeIds && !item.category.requireAllShowingBadges && item.category.requireShowingBadges === (_.intersection(item.category.showingBadgeIds, showingBadgeIds).length > 0))
      return item.active && (!this.$consumer || (item.availableOnline && isCategoryAvailableForShowing))
    }
  }
}
